import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { IssueScopeKind } from '../../../../../shared/issuesV2';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import type { DependencyUsage } from '../../../../../shared/issuesV2';

import WithSeparator from './WithSeparator';

const DEPTH_LABEL: Record<DependencyUsage, string> = {
  direct: 'Direct',
  deep: 'Transitive',
};

/**
 * Indicates the "depth" of the dep at which the issue was found.
 */
const DepthIndicator = ({ depths }: {depths: Record<DependencyUsage, number>}) => {
  const { type: scopeType } = useSelector(IssuesV2Store.selectors.getScope);

  const depthText = useMemo(() => Object.entries(DEPTH_LABEL)
    .filter(([key]) => key in depths && depths[key as DependencyUsage] > 0)
    .map(([key, label]) =>
      scopeType === IssueScopeKind.Project
        ? label
        : `${label} (${depths[key as DependencyUsage].toLocaleString()})`,
    )
    .join(' + '), [depths, scopeType]);

  return (
    <WithSeparator>
      <div className="issue-item__text">
        {depthText}
      </div>
    </WithSeparator>
  );
};

export default DepthIndicator;
